<template>
    <div class="pdf-wrapper">
      <div v-for="(pag, index) in pagesToPDF" :key="index">
        <section class="pdf-page" :style="pageWidth">
          <div class="header">
            <img v-if="logo && showLogo"
              :src="logo" alt="" class="modal-logo" height="37px"
            />
			<label v-else class="title">{{ profileUserConfig.enterprise || title }}</label>
          </div>
          <div>
            <b-row>
              <b-col cols="10">
                <label :style="fontSize">{{ title }} </label>
              </b-col>
              <b-col cols="2" style="text-align: right;">
                <label :style="fontSize">Pag. {{ index + 1 }}/{{ pagesToPDF.length }}</label>
              </b-col>
            </b-row>
            <b-row class="info">
              <b-col cols="3">
                <label :style="fontSize">Data: {{ headerData.date || '-' }} {{ headerData.hour || '-' }}</label>
              </b-col>
              <b-col cols="9">
                <label :style="fontSize">Usuário: {{ headerData.user ||'-' }}</label>
              </b-col>
            </b-row>
            <b-row class="info">
              <b-col>
                <div>
				  <label :style="fontSize">Filtros:</label>
				  <label :style="fontSize" class="ml-1">{{filtersKeys}}</label>
                  <br/>
                </div>
              </b-col>
			</b-row>
			<b-row class="info mb-1">
              <b-col v-if="filterData && (filterData.initDate || filterData.endDate)">
                <label :style="fontSize">Periodo: {{ formatterSimple(filterData.initDate) }} - {{ formatterSimple(filterData.endDate) }}</label>
              </b-col>
            </b-row>
          </div>
          <div :style="tableStyle">
			<table>
				<thead>
					<tr class="bg-title-dark">
						<th v-for="(col, idx) in fields" :key="idx" :style="{...col.style, ...fontSize}" class="font-weight-bold">
						{{ col.label }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in pag" :key="idx"
						class="row-height"
						v-bind:class="idx % 2 !== 0 ? 'bg-row-dark' : ''"
					>
						<td v-for="(col, idx_col) in fields" :key="idx_col">
							<label
								style="margin-bottom: 0px; padding-top: 8px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
								:style="{...col.style, ...fontSize}" :class="item.class ? item.class : ''">{{ item[col.key] }}</label>
						</td>
					</tr>
				</tbody>
			</table>
          </div>
          <div class="footer">Sistema desenvolvido por Samir Gannem - Informática SG - https://informaticasg.com.br</div>
        </section>
      </div>
    </div>
</template>

<script>

	import { numberFormatted, formatterSimple } from "@/helpers/common";
	import { STATUS_RECEIVE } from "@/helpers/enums";

	export default {
		components: {},

		computed: {
			headers () {
				return this.rows.length && Object.keys(this.rows[0]);
			},

			fontSize () {
				const fs = `${this.fontSizeReport}px`;
				return {
					"font-size": fs
				};
			},
			tableStyle () {
				const ajustAdd = this.filterData && (this.filterData.initDate || this.filterData.endDate) ? -8 : 0;
				const height = (12 * this.rowsPerPage) + (this.adjustHeightPage + ajustAdd);
				return {
					height: `${height}mm`
				};
			},
			pageWidth () {
				const width = this.widthPage;
				return {
					width
				};
			}
		},

		props: {
			headerData: {
				type: Object,
				default () {
					return {};
				}
			},
			filterData: {
				type: Object,
				default () {
					return {};
				}
			},
			rows: {
				type: Array
			},
			title: {
				type: String,
				default: ""
			},
			fields: {
				type: Array
			},
			config: {
				type: Object,
				require: false
			},
			showLogo: {
				type: Boolean,
				require: false,
				default: false
			},
			isMobile: {
				type: Boolean,
				require: false,
				default: false
			},
			installments: {
				type: Array,
				require: false,
				default: null
			},
			footer: {
				type: Object,
				required: false,
				default: null
			},
			rowsPerPage: {
				type: Number,
				required: false,
				default: 14
			},
			fontSizeReport: {
				type: String,
				required: false,
				default: ""
			},
			widthPage: {
				type: String,
				required: false,
				default: ""
			},
			adjustHeightPage: {
				type: Number,
				required: false,
				default: 0
			},
			filtersKeys: {
				type: String,
				required: false,
				default: ""
			}
		},

		data () {
			return {
				profileUserConfig: {},
				logo: null,
				numberFormatted,
				watermark: null,
				STATUS_RECEIVE,
				formatterSimple,
				pages: 0,
				pagesToPDF: []
			};
		},

		watch: {
			showLogo: "getLogo",
			rows (newVal) {
				this.pages = newVal.length / this.rowsPerPage;
				this.pagesToPDF = [];
				for (let i = 0; i < newVal.length; i += this.rowsPerPage) {
					this.pagesToPDF.push(newVal.slice(i, i + this.rowsPerPage));
				}
			}
		},

		mounted () {
			this.profileUserConfig = localStorage.params ? JSON.parse(localStorage.params) : {};
			this.getLogo();
		},

		methods: {
			getLogo () {
				if (this.showLogo) {
					this.logo = this.profileUserConfig.logo;
				}
			}
		}
	};
</script>

<style scoped>
	.center {
		text-align: center;
	}

	.right {
		text-align: right;
	}

	.left {
		text-align: left;
	}

	.footer {
		text-align: left;
		border-top: 1px solid #9c9b9b;
		font-style: italic;
		font-size: 10px !important;
	}

	* {
		font-weight: 400;
		font-size: 16px;
	}

	.info {
		margin-top: -10PX;
	}

	.header .title {
		font-weight: 500;
		font-size: 18px;
		margin-bottom: 0px;
		margin-left: -10px;
	}

	.pdf-wrapper {
		height: auto;
		overflow: visible;
	}

	.pdf-page {
		width: 297mm;
		min-height: 210mm;
		padding: 5mm;
		box-sizing: border-box;
		background: white;
	}

	.table-report {
		height: 168mm;
	}

	.bg-row-dark {
		background-color: #e0dfdf;
	}

	.bg-title-dark {
		background-color:#e0dfdf;
		height: 2.5rem;
	}

	.row-height {
		height: 2.5rem;
	}

	.modal-logo {
		margin-top: -5px;
		margin-bottom: -5px;
	}
</style>